var React = require('react');

function Compose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.6,3.3l0.9-1c0.5-0.5,0.5-1.2,0-1.7l-0.3-0.3c-0.4-0.4-1.2-0.3-1.6,0.1l-0.9,0.9L22.6,3.3z M8.9,15.6l2.5-1L21.8,4.1\n\tl-2-1.9L9.5,12.6L8.4,15C8.3,15.3,8.6,15.7,8.9,15.6z M4.3,23.6h13.6c2.4,0,3.8-1.4,3.8-4V7.4L19,10.1v9.3c0,1.1-0.6,1.6-1.3,1.6\n\tH4.6c-1,0-1.6-0.5-1.6-1.6V6.6C3,5.5,3.6,5,4.6,5H14l2.7-2.7H4.3c-2.6,0-4,1.4-4,4v13.4C0.3,22.2,1.7,23.6,4.3,23.6z","fill":"currentColor"}));
}

Compose.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 24 24","style":{"enableBackground":"new 0 0 24 24"},"xmlSpace":"preserve"};

module.exports = Compose;

Compose.default = Compose;
